export default __webpack_public_path__ + "static/media/events.f6a2a261.svg";